import script from "./AddEnquiry.vue?vue&type=script&setup=true&lang=js"
export * from "./AddEnquiry.vue?vue&type=script&setup=true&lang=js"

import "./AddEnquiry.vue?vue&type=style&index=0&id=7b6c805d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b6c805d"]])

export default __exports__